import { createSelector } from 'reselect';

export const selectUserContext = state => state.userContext;
export const selectOddsFormat = state => state.userContext.oddsFormat;
export const selectCountryISO3 = state => state.userContext.countryISO3;
export const selectLangISO2 = state => state.userContext.langISO2;
export const selectIsBOGCountry = createSelector([selectCountryISO3], (countryISO3) => ['GBR', 'IRL'].indexOf(countryISO3) > -1);
